import React, { Component } from 'react';
import './EditNoteModal.css';
import moment from 'moment';
import { getColor, getTextColor } from '../../common/ThemeService';

class EditNoteModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentNote: "",
            emptyNoteError: false,
            showOptions: -1,
            openMenu: -1,
            editNoteObject: null,
            editModeOn: false,
            editNoteIndex: -1,
            inputFocusClass: false,
        }
    }

    postNote = () => {
        if (this.state.editModeOn) {
            this.props.editNote(this.state.currentNote, this.state.editNoteObject.noteId)
        } else {
            this.props.addNote(this.state.currentNote);
        }
        this.setState({
            currentNote: "",
            editModeOn: false,
            editNoteObject: null,
            editNoteIndex: -1,
        })
    }
    deleteNote = (noteId) => {
        this.props.deleteNote(noteId);
    }

    getFormattedDate = (date) => {
        const weeks = moment().utc().diff(moment(date).utc(), "weeks");
        if (weeks > 0) {
            return `${weeks} week${weeks === 1 ? "" : "s"} ago`;
        }
        const days = moment().utc().diff(moment(date).utc(), "days");
        if (days > 0) {
            return `${days} day${days === 1 ? "" : "s"} ago`;
        }
        const hours = moment().utc().diff(moment(date).utc(), "hours");
        if (hours > 0) {
            return `${hours} hour${hours === 1 ? "" : "s"} ago`;
        }
        const minutes = moment().utc().diff(moment(date).utc(), "minutes");
        if (minutes > 0) {
            return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
        }
        const seconds = moment().utc().diff(moment(date).utc(), "seconds");
        if (seconds > 15) {
            return `${seconds} seconds ago`;
        } else {
            return 'just now'
        }
    }

    render() {
        const themeColor = getColor()
        const themeTextColor = getTextColor()
        const notes = this.props.hand && this.props.hand.notes ? this.props.hand.notes.filter((noteObj) => noteObj ? true : false).sort((a, b) => moment(a.createdTime).valueOf() - moment(b.createdTime).valueOf()) : [];
        return (
            <div id="EditNoteModal" className="modal fade" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog ENM_ModalDialog" role="document">
                    <div className="modal-content ENM_content">
                        <div className="modal-header EditNoteModal_modal_header">
                            <div className="EditNoteModal_close" data-dismiss="modal" onClick={()=>{
                                this.props.setShowNoteModal(false)
                             }} ><i className="fa fa-times" data-e2e="close"></i></div>
                            <div className="EditNoteModal_title">{this.props.i18next.t("lable.handNotes")}</div>
                        </div>
                        <div className="EditNoteModal_modalBody" id="EditNoteModal_modalBody">
                            {notes.map((noteObj, i) => {
                                if (noteObj) {
                                    if (noteObj.user === "whiz") {
                                        return <div key={i} className="whiz_noteMsg_wrap">
                                            <img className="EditNoteModal_chat_icon" src={"/images/MyHands/ChatWhizIcon.svg"} />
                                            <div className="whiz_noteMsg">
                                                <div className="EditNoteModal_userNameAndTime_whiz">
                                                    <div className="EditNoteModal_userName_whiz">
                                                        {noteObj.user}
                                                    </div>
                                                    <div className="EditNoteModal_time_whiz">
                                                        {this.getFormattedDate(noteObj.createdTime)}
                                                    </div>
                                                </div>
                                                <div className="EditNoteModal_noteMsgText_whiz">
                                                    {noteObj.note}
                                                </div>
                                            </div>
                                        </div>
                                    } else {
                                        return <div key={i} className="player_noteMsg_wrap"
                                            onMouseEnter={(e) => {
                                                e.preventDefault()
                                                this.setState({ showOptions: i })
                                            }}
                                            onMouseLeave={(e) => {
                                                e.preventDefault()
                                                this.setState({ showOptions: -1 })
                                            }}>
                                            <div className="player_noteMsg">
                                                <div className="EditNoteModal_userNameAndTime_player">
                                                    <div className="EditNoteModal_userName_player">
                                                        {noteObj.user}
                                                    </div>
                                                    <div className="EditNoteModal_time_player">
                                                        {this.getFormattedDate(noteObj.createdTime)}
                                                    </div>
                                                </div>
                                                <div className="EditNoteModal_noteMsgText_player">
                                                    {noteObj.note}
                                                </div>
                                            </div>
                                            <span>
                                                {this.state.showOptions === i && <div className="option_dots_wrap" id={"option_dots_wrap" + i} onClick={(e) => {
                                                    e.preventDefault();
                                                    if (this.state.openMenu != i) {
                                                        this.setState({ openMenu: i }, () => {
                                                            document.getElementById('optionMenu_wrap').focus();
                                                        })
                                                    } else {
                                                        this.setState({ openMenu: -1 })
                                                    }
                                                }}>
                                                    <div className="option_ots" />
                                                    <div className="option_ots" />
                                                    <div className="option_ots" />
                                                </div>}
                                                {this.state.openMenu === i && <div tabIndex="50" id="optionMenu_wrap"
                                                    onBlur={(e) => {
                                                        e.preventDefault();
                                                        var dummyEl = document.getElementById('myID');
                                                        if (!document.getElementById('option_dots_wrap' + i) || (document.activeElement === dummyEl)) {
                                                            this.setState({ openMenu: -1 });
                                                        }
                                                    }}
                                                    className="optionMenu_wrap">
                                                    <div className="ENM_menuItem" onClick={(e) => {
                                                        e.preventDefault();
                                                        this.setState({
                                                            editNoteObject: noteObj,
                                                            editModeOn: true,
                                                            currentNote: noteObj.note,
                                                            editNoteIndex: i,
                                                            showOptions: -1,
                                                            openMenu: -1,
                                                        });
                                                        document.getElementById("EditNoteModal_addnoteInput").focus();
                                                        this.setState({ inputFocusClass: true })
                                                        setTimeout(() => {
                                                            this.setState({ inputFocusClass: false })
                                                        }, 700)
                                                    }}>{this.props.i18next.t("lable.edit")}</div>
                                                    <div className="ENM_menuItem" onClick={(e) => {
                                                        e.preventDefault();
                                                        this.deleteNote(noteObj.noteId);
                                                        this.setState({
                                                            showOptions: -1,
                                                            openMenu: -1,
                                                        });
                                                        if (this.state.editNoteIndex === i) {
                                                            this.setState({
                                                                currentNote: "",
                                                                editModeOn: false,
                                                                editNoteObject: null,
                                                                editNoteIndex: -1,
                                                            });
                                                        }
                                                    }}>{this.props.i18next.t("lable.delete")}</div>
                                                </div>}
                                                <img className="EditNoteModal_chat_icon_player" src={"/images/MyHands/User_Chat_icon.svg"} />
                                            </span>
                                        </div>
                                    }
                                }
                            })}
                        </div>
                        <div className="EditNoteModal_footer">
                            <img className="EditNoteModal_footer_icon" src={"/images/MyHands/User_Chat_icon.svg"} />
                            <div className="ENM_Inputs">
                                <input type="text" placeholder="Add a note" data-e2e="Add a note" id="EditNoteModal_addnoteInput" value={this.state.currentNote} onChange={(e) => {
                                    this.setState({ currentNote: e.target.value })
                                }} className={`form-control EditNoteModal_addnoteInput ${this.state.inputFocusClass ? "ENM_inputFocus" : ""} ${this.state.emptyNoteError ? "ENM_red_border" : ""}`}
                                />
                                <div className="ENM_button_wrap">
                                    <div className="EditNoteModal_postnote EditNoteModal_cancel" onClick={(e) => {
                                        e.preventDefault()
                                        this.setState({ currentNote: "" })
                                    }} data-e2e="cancel" >{this.props.i18next.t("lable.cancel")}</div>
                                    <div className={`EditNoteModal_postnote ${this.state.currentNote != "" ? "EditNoteModal_postnote_active" : ""}`}
                                        style={ this.state.currentNote != "" ? { 
                                            color: themeTextColor,
                                            backgroundColor: themeColor }: 
                                            {}}
                                        onClick={(e) => {
                                            e.preventDefault()
                                            if (this.state.currentNote != "") {
                                                this.postNote()
                                            } else {
                                                this.setState({ emptyNoteError: true })
                                                setTimeout(() => {
                                                    this.setState({ emptyNoteError: false })
                                                }, 700)
                                            }
                                        }} data-e2e="post" >{this.props.i18next.t("lable.post")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default EditNoteModal


/** WEBPACK FOOTER **
 ** ./src/components/HandHistory/EditNoteModal.js
 **/